var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('global-header'),_c('transition',{attrs:{"name":"router-transition"}},[_c('router-view')],1),_c('global-footer')],1)}
var staticRenderFns = []

export { render, staticRenderFns }